export {
    ToolSecondaryEquipmentFormComponent
}from "./tool-secondary-equipment-form/tool-secondary-equipment-form.component";
export { ToolPartNumbersFormComponent } from "./tool-part-numbers-form/tool-part-numbers-form.component";
export { ToolMainEquipmentFormComponent } from "./tool-main-equipment-form/tool-main-equipment-form.component";
export { ToolLocationFormComponent } from "./tool-location-form/tool-location-form.component";
export { ToolLifecycleFormComponent } from "./tool-lifecycle-form/tool-lifecycle-form.component";
export { ToolDetailsFormComponent } from "./tool-details-form/tool-details-form.component";
export { ToolBackupsComponent } from "./tool-backups/tool-backups.component";
